import queryString from 'query-string';

export default {
  redirctLogin({ url, query }: { url: string; query: { [key: string]: any } }) {
    const q = queryString.stringify(query);
    let qt = '';
    const lang = query?.language
      ? `/${query.language}`
      : `/${localStorage.BYBIT_LANG_KEY || 'en'}`;
    if (q) {
      qt = `?${q}`;
    }

    let _url: string = location.origin + `${lang}/login`;

    if (qt) {
      _url += `/${qt}`;
    }
    window.location.href = _url;
  },
  redirectLogin(search = location.search) {
    const routeObj: any = queryString.parseUrl(location.pathname + search);
    this.redirctLogin(routeObj);
  },
  redirectHome() {
    const lang = localStorage.BYBIT_LANG_KEY || 'en';
    window.location.href = '/' + lang;
  },
};
